import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import validator from 'validator';
import SideNav from './Partials/SideNav';
import { qprService, teamService } from '../../../../Services';
import { qprActions } from '../../../../Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const BasicInfromationForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  let qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [drafted, setDrafted] = useState(false);

  const [input, setInput] = useState(qpr.basic_information && Object.keys(qpr.basic_information).length>0? qpr.basic_information: {
    name: '',
    sanctioned_amount: '',
    fund_received_date: '',
    expenditure_status: '',
    mentor_name: '', 
    mentor_email: '', 
    mentor_organization: '', 
    mentor_designation: '',
    research_title: '',
    report_start_date: '',
    report_end_date: '',
  });

  if(input.sanctioned_amount == "") {
    input.sanctioned_amount = 7500;
  }

  useEffect( () => {
    if(typeof qpr.basic_information == "undefined" || qpr.basic_information.id!=qpr_id) {
      localStorage.removeItem("qpr_data");
      qpr = {};
      dispatch(qprActions.qprData(qpr));
      qprService.basicInformation(qpr_id).then(async rslt => {
        if(rslt.status == 401) {
          navigate("/logout");
        }
        Object.keys(rslt.data.basic_information).map(val => {
          rslt.data.basic_information[val] = rslt.data.basic_information[val] ?? "";
        });
        qpr.basic_information = rslt.data.basic_information;
        qpr.form_validation = JSON.parse(rslt.data.basic_information.form_validation);
        if(!qpr.basic_information.name) {
          await teamService.list().then( res => {
            let team = res.data.list;
            let name = "";
            team.map(val => {
              if(val.surName) {
                name += val.surName+" ";
              }
              name += val.fullname? val.fullname+"|": val.firstName+" "+val.lastName+"|";
            });
            qpr.basic_information.name = name.slice(0, -1);
          });
        }
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setInput(qpr.basic_information);
      });
    }
    if(qpr.basic_information && qpr.basic_information.user_status == 1) {
      navigate("/user/home");
    }
  }, []);

  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }
  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      let not_validate = ["user_status"];
      if(qpr.basic_information.quarter == 1) {
        not_validate.push("report_start_date", "report_end_date");
      }
      if(input[item] == "" && not_validate.includes(item) == false) {
        error[item] = "Required";
      }

      if(input[item]) {
        switch(item) {
          case "sanctioned_amount":
            if(!validator.isNumeric(String(input['sanctioned_amount']))) {
              error[item] =  "Number only";
            }
            break;
          // case "mentor_email":
          //   if(!validator.isEmail(input['mentor_email'])) {
          //     error[item] =  "Invalid email";
          //   }
          //   break;
          
          default:
            break;
        }
      }
    });
    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      console.log(ref_focus_key);
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = (submit_status, fnctn) => {
    setValidationError({});
    qpr.form_validation.basic_information.submit_status = 0;
    input.submit_status = 0;
    if(submit_status == 1) {
      input.submit_status = 1;
      if(Object.keys(checkValidation()).length > 0) {
        fnctn(false);
        return false;
      }
      qpr.form_validation.basic_information.submit_status = 1;
    }
    input.form_validation = JSON.stringify(qpr.form_validation);
    qprService.basicInformationSave(input, qpr_id).then(rslt => {
      Object.keys(rslt.data.basic_information).map(val => {
        rslt.data.basic_information[val] = rslt.data.basic_information[val] ?? "";
      });
      qpr.basic_information = rslt.data.basic_information;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      fnctn(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let submit_status = e.target.dataset.submit_status;
    let fnctn = submit_status==1? setSubmitted: setDrafted;
    fnctn(true);
    submitForm(submit_status, fnctn);
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  {qpr.form_validation && <SideNav />}
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Basic Information</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className="singel-form">
                            <h6>Team:</h6>
                            {/* <label>Team<span className='text-danger'>*</span>:</label> */}
                            {/* <input name="name" type="text" value={input.name? input.name: input.name} ref={r => {ref.current['name'] = r}} onChange={handleChange} />
                            {validationError.name && <span className='text-danger'>{validationError.name}</span>} */}
                            {input.name && input.name.split("|").map((val, key) => {
                              return(
                                <div key={key}>
                                  <p className='pl-3'>{val}</p>
                                </div>
                              );
                            })}
                          </div>
                          <hr/>
                          <div className="singel-form">
                            <h6>Status of Grant:</h6>
                            <div className='row'>
                              <div className='col-md-4'>
                                <label>Sanctioned amount (in $)<span className='text-danger'>*</span>:</label>
                                <input name="sanctioned_amount" type="text" value={input.sanctioned_amount? input.sanctioned_amount: ""} ref={r => {ref.current['sanctioned_amount'] = r}} onChange={handleChange} />
                                {validationError.sanctioned_amount && <span className='text-danger'>{validationError.sanctioned_amount}</span>}
                              </div>
                              <div className='col-md-4'>
                                <label>Date of fund received<span className='text-danger'>*</span>:</label>
                                <input name="fund_received_date" type="date" value={input.fund_received_date? input.fund_received_date: ""} ref={r => {ref.current['fund_received_date'] = r}} onChange={handleChange} />
                                {validationError.fund_received_date && <span className='text-danger'>{validationError.fund_received_date}</span>}
                              </div>
                              <div className='col-md-4'>
                                <label>Status of expenditure<span className='text-danger'>*</span>:</label>
                                <input name="expenditure_status" type="text" value={input.expenditure_status? input.expenditure_status: ""} ref={r => {ref.current['expenditure_status'] = r}} onChange={handleChange} />
                                {validationError.expenditure_status && <span className='text-danger'>{validationError.expenditure_status}</span>}
                              </div>
                            </div>
                          </div>
                          <hr/>
                          <div className="singel-form">
                            <h6>Mentor Info:</h6>
                            <div className='row'>
                              <div className='col-md-6'>
                                <label>Name<span className='text-danger'>*</span>:</label>
                                <input name="mentor_name" type="text" value={input.mentor_name? input.mentor_name: ""} ref={r => {ref.current['mentor_name'] = r}} onChange={handleChange} />
                                {validationError.mentor_name && <span className='text-danger'>{validationError.mentor_name}</span>}
                              </div>
                              <div className='col-md-6'>
                                <label>Email<span className='text-danger'>*</span>:</label>
                                <input name="mentor_email" type="text" value={input.mentor_email? input.mentor_email: ""} ref={r => {ref.current['mentor_email'] = r}} onChange={handleChange} />
                                {validationError.mentor_email && <span className='text-danger'>{validationError.mentor_email}</span>}
                              </div>
                              <div className='col-md-6'>
                                <label>Organization<span className='text-danger'>*</span>:</label>
                                <input name="mentor_organization" type="text" value={input.mentor_organization? input.mentor_organization: ""} ref={r => {ref.current['mentor_organization'] = r}} onChange={handleChange} />
                                {validationError.mentor_organization && <span className='text-danger'>{validationError.mentor_organization}</span>}
                              </div>
                              <div className='col-md-6'>
                                <label>Designation<span className='text-danger'>*</span>:</label>
                                <input name="mentor_designation" type="text" value={input.mentor_designation? input.mentor_designation: ""} ref={r => {ref.current['mentor_designation'] = r}} onChange={handleChange} />
                                {validationError.mentor_designation && <span className='text-danger'>{validationError.mentor_designation}</span>}
                              </div>
                            </div>
                          </div>
                          <hr/>
                          <div className="singel-form">
                            <h6>Title of research<span className='text-danger'>*</span>:</h6>
                            <input name="research_title" type="text" value={input.research_title? input.research_title: ""} ref={r => {ref.current['research_title'] = r}} onChange={handleChange} />
                            {validationError.research_title && <span className='text-danger'>{validationError.research_title}</span>}
                          </div>
                          {(qpr.basic_information && qpr.basic_information.quarter != 1) &&
                          <div className="singel-form">
                            <h6>Period of report<span className='text-danger'>*</span>:</h6>
                            <div className='row'>
                              <div className='col-md-5'>
                                <input name="report_start_date" type="date" value={input.report_start_date? input.report_start_date: ""} ref={r => {ref.current['report_start_date'] = r}} onChange={handleChange} />
                                {validationError.report_start_date && <span className='text-danger'>{validationError.report_start_date}</span>}
                              </div>
                              <div className='col-md-2 text-center'>To</div>
                              <div className='col-md-5'>
                                <input name="report_end_date" type="date" value={input.report_end_date? input.report_end_date: ""} ref={r => {ref.current['report_end_date'] = r}} onChange={handleChange} />
                                {validationError.report_end_date && <span className='text-danger'>{validationError.report_end_date}</span>}
                              </div>
                            </div>
                          </div>
                          }
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type="button" className="main-btn btn-info btn-outline-info disabled" onClick={handleSubmit} data-tip data-for="draft">
                              {drafted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Draft</span>}
                            </button>
                            <ReactTooltip id="draft" place="top" effect="solid">
                              You can save the form as draft if you do not have all the required information to fill
                            </ReactTooltip>
                            <button type="submit" className="main-btn btn-info ml-3 disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BasicInfromationForm;